import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DynamicContentWrapperComponent } from '@digital-platform/rs-cms/feature-ptypes';
import { RsCmsServicesModule } from '@digital-platform/rs-cms/services';
import { FooterComponent } from './footer/footer.component';
import { EmailValidationService } from './preference-center/email-validation.service';
import { PreferenceCenterService } from './preference-center/preference-center.service';

@NgModule({
  imports: [
    CommonModule,
    RsCmsServicesModule,

    DynamicContentWrapperComponent,
    RouterModule.forChild([
      {
        path: '',
        pathMatch: 'full',
        component: FooterComponent,
      },
    ]),
  ],
  providers: [EmailValidationService, PreferenceCenterService],
  declarations: [FooterComponent],
})
export class RsFooterFeatureFooterModule {}
